import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';
import { type User } from 'hb-react/types';

import v1 from './v1';
import v2 from './v2';

export interface UseShouldDisplayInternalMessagingActionProps {
  enabled?: boolean;
  isFeatureActive?: boolean;
  onlyCurrentUser?: boolean;
  user: Pick<User, 'id'> | null;
}

export const useShouldDisplayInternalMessagingAction = (
  props: UseShouldDisplayInternalMessagingActionProps,
) => {
  const { flagEvMessagingReactQuery } = useFeatureFlag();

  if (flagEvMessagingReactQuery) {
    return v2(props);
  }

  return v1(props);
};
